// Imports
import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Rx';

import { XhrService } from '../../../service/xhr.service';

// Import RxJs required methods
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';

import { PostBody } from '../../../shared/postBody';

import { User } from './user';

@Injectable()
export class UserService {
    // Resolve HTTP using the constructor
    constructor(private xhrService: XhrService) {
    }

    getInfo() {
        return this.xhrService.get('user/getInfo/');
    }

    getClone(id: number) {
        return this.xhrService.get('user/getInfo/' + id);
    }

    get(id: number) {
        return this.xhrService.get('user/read/' + id);
    }

    getAll() {
        return this.xhrService.get('user/read/');
    }

    create(user:User) {
        let postBody:PostBody={method:'user.create'};
        postBody['user'] = user;
        return this.xhrService.post('user/create/',postBody);
    }

    update(id:number,user:User) {
        let postBody:PostBody={method:'user.update'};
        postBody['user'] = user;
        return this.xhrService.post('user/update/'+id,postBody);
    }

    delete(id:number) {
        return this.xhrService.get('user/delete/'+id);
    }


}



// WEBPACK FOOTER //
// ./src/app/module/user/shared/user.service.ts